import {v4 as uuid} from 'uuid';

const handleResponse = (response, endpointUrl) => {
    if(response.ok) {
        if (201 === response.status) {
            return response.headers.get('Location') || endpointUrl;
        } else if (204 === response.status) {
            return true
        } else {
            return response.json()
        }
    } else {
        return Promise.reject(response.status)
    }
};

const fetchResponse = (endpointUrl, configuration, maxTries) => {
    return fetch(endpointUrl, configuration)
        .then(response => {
            if(503 === response.status || 504 === response.status) {
                return Promise.reject('retry')
            } else {
                return handleResponse(response, endpointUrl)
            }
        })
        .catch(error => {
            if('retry' === error && 0 !== maxTries) {
                return fetchResponse(endpointUrl, configuration, maxTries - 1);
            } else {
                return Promise.reject(error)
            }
        })
};

const constructUrl = (useApiGateway, url) => {
    if(useApiGateway && !url.startsWith('http')) {
        return `${getApiGateway()}${url}`
    } else {
        return url
    }
}

const getApiGateway = () => {
    if(window._env_ && window._env_.REACT_APP_API_GATEWAY) {
        return window._env_.REACT_APP_API_GATEWAY;
    } else {
        return process.env.REACT_APP_API_GATEWAY;
    }
}

const kitFetchFactory = ({useApiGateway=false, jsonType=true}) => (url, configuration={}) => {
    const token = localStorage.getItem('kit.access_token');
    const idToken = localStorage.getItem('kit.id_token')
    const {headers: userHeaders, ...configurationWithoutHeaders} = configuration

    const headers = new Headers({
        'Authorization': `Bearer ${token}`,
        'Correlation-Id': uuid()
    });

    if(jsonType) {
        headers.append('Content-Type', 'application/json')
    }

    if(idToken) {
        headers.append('Id-Token', idToken)
    }

    if(userHeaders) {
        if(userHeaders instanceof Headers) {
            for (const pair of userHeaders.entries()) {
                headers.append(pair[0], pair[1])
            }
        } else {
            Object.entries(userHeaders).forEach(([key, value]) => {
                headers.append(key, value)
            })
        }
    }

    const newConfiguration = {
        headers,
        ...configurationWithoutHeaders
    };

    const endpointUrl = constructUrl(useApiGateway, url);

    if(jsonType) {
        return fetchResponse(endpointUrl, newConfiguration, 3);
    } else {
        return fetch(endpointUrl, newConfiguration)
    }

};

/**
 * Attaches Authorization header and fetches an api outside the apigateway.
 * @type {function(*, *=): Promise<Response>}
 */
export const kitFetchExternal = kitFetchFactory({});

/**
 * Attaches Authorization header and fetches api through api gateway.
 * Api gateway must be defined in process.env.REACT_APP_API_GATEWAY or window._env_.REACT_APP_API_GATEWAY.
 * Example: kitFetch('/museum-api/museums')
 * @type {function(*, *=): Promise<Response>}
 */
export const kitFetch = kitFetchFactory({
    useApiGateway: true
});

/**
 * Attaches Authorization header and fetches api through api gateway.
 * Api gateway must be defined in process.env.REACT_APP_API_GATEWAY or window._env_.REACT_APP_API_GATEWAY.
 * Doesn't set Content-Type.
 * @type {function(*, *=): Promise<Response>}
 */
export const kitFileUpload = kitFetchFactory(({
    useApiGateway: true,
    jsonType: false
}));

/**
 * Attaches Authorization header and fetches api without using the api gateway.
 * Doesn't set Content-Type.
 * @type {function(*, *=): Promise<Response>}
 */
export const kitFileUploadExternal = kitFetchFactory(({
    useApiGateway: false,
    jsonType: false
}));

export const kitGetBlob = kitFileUpload